import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { INITIAL_ASSETS } from './constants';

const assetsSlice = createSlice({
  name: 'assets',
  initialState: {
    items: INITIAL_ASSETS,
    filters: { search: '', category: '', state: '', locationId: '' },
  },
  reducers: {
    addAsset(state, { payload }) {
      const now = new Date().toISOString();
      state.items.push({
        ...payload,
        id: payload.id ?? uuidv4(),
        maintenanceHistory: payload.maintenanceHistory ?? [],
        createdAt: now,
        updatedAt: now,
        syncStatus: 'pending',
      });
    },
    updateAsset(state, { payload }) {
      const idx = state.items.findIndex((a) => a.id === payload.id);
      if (idx < 0) return;
      state.items[idx] = {
        ...state.items[idx],
        ...payload,
        updatedAt: new Date().toISOString(),
        syncStatus: 'pending',
      };
    },
    deleteAsset(state, { payload: id }) {
      state.items = state.items.filter((a) => a.id !== id);
    },
    addMaintenanceEntry(state, { payload: { assetId, entry } }) {
      const asset = state.items.find((a) => a.id === assetId);
      if (!asset) return;
      asset.maintenanceHistory = [
        { ...entry, id: entry.id ?? uuidv4() },
        ...(asset.maintenanceHistory ?? []),
      ];
      asset.lastMaintenance = entry.date;
      asset.updatedAt = new Date().toISOString();
      asset.syncStatus = 'pending';
    },
    deleteMaintenanceEntry(state, { payload: { assetId, entryId } }) {
      const asset = state.items.find((a) => a.id === assetId);
      if (!asset) return;
      asset.maintenanceHistory = asset.maintenanceHistory.filter(
        (e) => e.id !== entryId
      );
      asset.updatedAt = new Date().toISOString();
      asset.syncStatus = 'pending';
    },
    setFilter(state, { payload: { key, value } }) {
      state.filters[key] = value;
    },
    clearFilters(state) {
      state.filters = { search: '', category: '', state: '', locationId: '' };
    },
    markSynced(state, { payload: { id, serverUpdatedAt } }) {
      const asset = state.items.find((a) => a.id === id);
      if (!asset) return;
      asset.syncStatus = 'synced';
      if (serverUpdatedAt) asset.updatedAt = serverUpdatedAt;
    },
    applyServerUpdate(state, { payload: serverAsset }) {
      const idx = state.items.findIndex((a) => a.id === serverAsset.id);
      if (idx >= 0) {
        state.items[idx] = { ...serverAsset, syncStatus: 'synced' };
      } else {
        state.items.push({ ...serverAsset, syncStatus: 'synced' });
      }
    },
    markSyncError(state, { payload: id }) {
      const asset = state.items.find((a) => a.id === id);
      if (asset) asset.syncStatus = 'error';
    },
    resetToDefaults(state) {
      state.items = INITIAL_ASSETS;
      state.filters = { search: '', category: '', state: '', locationId: '' };
    },
  },
});

export const {
  addAsset,
  updateAsset,
  deleteAsset,
  addMaintenanceEntry,
  deleteMaintenanceEntry,
  setFilter,
  clearFilters,
  markSynced,
  applyServerUpdate,
  markSyncError,
  resetToDefaults,
} = assetsSlice.actions;

export default assetsSlice.reducer;
